import { atom } from 'recoil';
export const formDialogAtom = atom({
    key: '@zurich/ui/form/dialog',
    default: {},
});
export const formDialogOpenValidationAtom = atom({
    key: '@zurich/ui/form/dialogOpen',
    default: false,
});
